export type RelatorioTema =
  | 'racialEquality'
  | 'workforce'
  | 'procurement'
  | 'transfers'
  | 'regulation';

export interface Relatorio {
  readonly slug: string;
  readonly titleKey: string;
  readonly descriptionKey: string;
  readonly authorsKey: string;
  readonly dateKey: string;
  readonly publishedAt: string;
  readonly tema: RelatorioTema;
  readonly pages?: number;
  readonly pdfUrl: string;
  readonly partnerKey?: string;
}

export interface RelatorioTemaOption {
  readonly id: RelatorioTema;
  readonly labelKey: string;
  readonly descriptionKey: string;
}

export const RELATORIO_TEMAS: readonly RelatorioTemaOption[] = [
  {
    id: 'racialEquality',
    labelKey: 'pages.reports.themes.racialEquality.label',
    descriptionKey: 'pages.reports.themes.racialEquality.description',
  },
  {
    id: 'workforce',
    labelKey: 'pages.reports.themes.workforce.label',
    descriptionKey: 'pages.reports.themes.workforce.description',
  },
  {
    id: 'procurement',
    labelKey: 'pages.reports.themes.procurement.label',
    descriptionKey: 'pages.reports.themes.procurement.description',
  },
  {
    id: 'transfers',
    labelKey: 'pages.reports.themes.transfers.label',
    descriptionKey: 'pages.reports.themes.transfers.description',
  },
  {
    id: 'regulation',
    labelKey: 'pages.reports.themes.regulation.label',
    descriptionKey: 'pages.reports.themes.regulation.description',
  },
];

export const RELATORIOS: readonly Relatorio[] = [
  {
    slug: 'negro-o-suficiente-fronteiras-raciais',
    titleKey: 'pages.reports.items.racialBoundaries.title',
    descriptionKey: 'pages.reports.items.racialBoundaries.description',
    authorsKey: 'pages.reports.items.racialBoundaries.authors',
    dateKey: 'pages.reports.items.racialBoundaries.date',
    publishedAt: '2026-01-01',
    tema: 'racialEquality',
    pages: 8,
    pdfUrl:
      'https://repositorio.enap.gov.br/bitstream/1/10029/1/PB%20-%20Negro%20o%20suficiente.pdf',
  },
  {
    slug: 'rotatividade-fechamento-capacidade-burocratica',
    titleKey: 'pages.reports.items.bureaucraticCapacity.title',
    descriptionKey: 'pages.reports.items.bureaucraticCapacity.description',
    authorsKey: 'pages.reports.items.bureaucraticCapacity.authors',
    dateKey: 'pages.reports.items.bureaucraticCapacity.date',
    publishedAt: '2026-01-01',
    tema: 'workforce',
    pages: 9,
    pdfUrl:
      'https://repositorio.enap.gov.br/bitstream/1/10030/1/PB%20-%20Rotatividade%2c%20fechamento%20e%20capacidade%20burocr%c3%a1tica%20no%20BR.pdf',
  },
  {
    slug: 'avaliacao-politica-cotas-2014-2024',
    titleKey: 'pages.reports.items.quotas.title',
    descriptionKey: 'pages.reports.items.quotas.description',
    authorsKey: 'pages.reports.items.quotas.authors',
    dateKey: 'pages.reports.items.quotas.date',
    publishedAt: '2024-12-20',
    tema: 'racialEquality',
    pages: 184,
    pdfUrl:
      'https://repositorio.enap.gov.br/bitstream/1/9261/1/Relat%C3%B3rio%20Cotas%20Completo.pdf',
    partnerKey: 'pages.reports.items.quotas.partner',
  },
];
